import { Button, Col, Row } from "antd";
import CheckWhiteIcon from "assets/images/icon/cert/check-white.svg";
import { KHCN_LOGO, VBC_LOGO_DARK } from "constants/images";
import { useMediaQuery } from "hooks/useMediaQuery";
import { useEffect } from "react";

const Header = () => {
  const isDesktop = useMediaQuery("(min-width: 1024px)");

  useEffect(() => {
    const scrollHandler = () => {
      let menuEle = document.getElementById("header");
      let tabEle = document.getElementById("asset-tab");
      let tabWrapEle = document.getElementById("asset-tab-wrap");

      if (isDesktop) {
        if (menuEle) {
          if (window.scrollY > 0) {
            menuEle.classList.add("shadow-lg");
          } else {
            menuEle.classList.remove("shadow-lg");
          }
        }
      } else {
        if (window.scrollY > 0) {
          if (tabEle && window.scrollY - tabEle?.offsetTop < 0) {
            menuEle?.classList.add("shadow-lg");
            tabWrapEle?.classList.remove("shadow-lg");
          } else {
            menuEle?.classList.remove("shadow-lg");
            tabWrapEle?.classList.add("shadow-lg");
          }
        } else {
          menuEle?.classList.remove("shadow-lg");
        }
      }
    };

    window.addEventListener("scroll", scrollHandler);

    return () => {
      window.removeEventListener("scroll", scrollHandler);
    };
  }, [isDesktop]);

  return (
    <div id="header" className="bg-white sticky top-0 z-[1000] duration-300">
      <div className="container max-w-full lg:max-w-[95vw] py-3">
        <Row>
          <Col span={13} xl={8} xxl={6}>
            <div className="flex items-center justify-start relative w-[180px] h-[70px] cursor-pointer">
              {/* <div
                className="w-[30px] h-[30px] lg:w-[45px] lg:h-[45px] relative mr-2 lg:mr-3 cursor-pointer"
                onClick={() => {
                  window.open("https://vietnamblockchain.asia/");
                }}
              >
                <img alt="" src={KHCN_LOGO} className="object-fill" />
              </div>
              <h1 className="text-2xs sm:text-xs lg:text-sm text-dark font-bold lg:leading-normal">
                VIETNAM BLOCKCHAIN
                <br /> CORPORATION
              </h1> */}
              <img alt="" src={VBC_LOGO_DARK} className="object-contain" />
            </div>
          </Col>
          <Col span={0} xl={8} xxl={12} className="hidden xl:block">
            <div className="flex items-center justify-center">
              <h1 className="text-sm lg:text-md lg:text-xl text-primary font-extrabold leading-loose text-center">
                {/* XÁC THỰC CHỨNG NHẬN
                <br /> ỨNG DỤNG CÔNG NGHỆ BLOCKCHAIN */}
                CERTIFICATE VERIFICATION
                <br /> APPLYING BLOCKCHAIN TECHNOLOGY
              </h1>
            </div>
          </Col>
          {/* <Col
            span={11}
            xl={8}
            xxl={6}
            className="flex items-center justify-end"
          >
            <Button
              // onClick={() =>
              //   openAlert({
              //     type: "develop",
              //   })
              // }
              disabled
              className="btn btn-primary flex items-center justify-center px-2 lg:px-4 py-2 text-xs md:text-sm"
            >
              <img
                src={CheckWhiteIcon}
                alt=""
                className="mr-1 lg:mr-2 inline-block w-[14px] h-[14px] lg:w-[16px] lg:h-[16px]"
              />
              Xác thực chứng nhận
            </Button>
          </Col> */}
        </Row>
      </div>
    </div>
  );
};

export default Header;
